import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  Link,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { updateDoc } from "firebase/firestore";
import { IconBriefcase, IconCheck } from "@tabler/icons-react";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import BusinessDb from "../../../../db/businessDb";
import Business from "../../../../models/business";
import UploadAvatar from "../../../util/ui/uploadAvatar";

type Props = { business: Business };

export default function Perfil({ business }: Props) {
  const [editar, setEditar] = useState(false);
  const [nome, setNome] = useState("");
  const [, setError] = useState("");

  const saveImage = async (file: HTMLCanvasElement) => {
    const imagemRef = ref(getStorage(), `/business/${business.id}/logo.jpeg`);

    await new Promise<Blob>((resolve, reject) => {
      file.toBlob((blob) => {
        if (!!blob) resolve(blob);
        else reject();
      });
    })
      .then((imageBlob) =>
        uploadBytes(imagemRef, imageBlob, {
          contentType: "image/jpeg",
        })
      )
      .then((u) => getDownloadURL(u.ref))
      .then((url) =>
        updateDoc(new BusinessDb().doc({ businessId: business.id }), {
          imagemUrl: url,
        })
      );
  };

  useEffect(() => {
    if (business) setNome(business.nome);
  }, [business]);

  return (
    <Container disableGutters>
      <Box display="flex" flexDirection="row" alignItems={"center"}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems={"center"}
          paddingRight={2}
        >
          <Avatar
            sx={{
              m: 2,
              height: 80,
              width: 80,
              fontSize: 40,
              bgcolor: "secondary.main",
            }}
            src={business?.imagemUrl || ""}
            alt={business?.nome || ""}
          >
            {business?.nome?.at(0) || <IconBriefcase size={40} />}
          </Avatar>
        </Box>
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography variant="h3" color="text.primary">
            {business?.nome || "Escritório"}
          </Typography>
          <Box paddingTop={1} />{" "}
          <Link
            onClick={() => setEditar(true)}
            variant="labelMono"
            color="accentInk"
            underline="hover"
            sx={{ cursor: "pointer" }}
          >
            Editar
          </Link>
        </Box>
      </Box>
      <Dialog
        maxWidth="xs"
        onClose={() => {
          setError("");
          setEditar(false);
        }}
        aria-labelledby="simple-dialog-title"
        open={editar}
      >
        <DialogTitle sx={{ typography: "h3" }}>Editar perfil</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="stretch">
            <Box alignSelf="center">
              <UploadAvatar onSave={saveImage}>
                <Avatar
                  sx={{ height: 100, width: 100 }}
                  src={business?.imagemUrl}
                  alt={business?.nome}
                />
              </UploadAvatar>
            </Box>
            <Box paddingY={2}>
              <Divider variant="fullWidth" />
            </Box>
            <FormControl
              variant="outlined"
              fullWidth
              margin="normal"
              color={business?.nome === nome ? "success" : undefined}
            >
              <Typography
                variant="labelMono"
                component="label"
                htmlFor="nome-input"
                color="text.secondary"
                mb={0.75}
              >
                Nome
              </Typography>
              <OutlinedInput
                id="nome-input"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() =>
                        updateDoc(
                          new BusinessDb().doc({ businessId: business.id }),
                          {
                            nome,
                          }
                        )
                      }
                      onMouseDown={(event) => event.preventDefault()}
                      edge="end"
                      size="large"
                      sx={(theme) => ({
                        color:
                          business?.nome === nome
                            ? theme.palette.success.main
                            : theme.palette.accentInk,
                      })}
                    >
                      <IconCheck strokeWidth={3} />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: "accentInk" }}
            onClick={() => setEditar(false)}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
